export default "/_next/static/chunks/fonts/Fontisto-c0edd68811e0237502fe94c365373ee0.ttf";